import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Event, NavigationEnd, Router} from '@angular/router';
import {BehaviorSubject, map} from 'rxjs';
import {BackendListModel} from '../models/common/list.model';
import {Sidebar} from '../models/sidebar';
import {ApiRoutes} from './apiroutes';
import {RouteMasterService} from '../route-master.service';

@Injectable({ providedIn: 'root' })
export class NavService {
    base_url = ApiRoutes.Company;

    public currentUrl = new BehaviorSubject<any>(undefined);

    navList: Sidebar;
    expanded: boolean = false;
    landingPage = new BehaviorSubject(false);

    constructor(
        private router: Router,
        private http: HttpClient,
        private routeMasterService: RouteMasterService
    ) {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.currentUrl.next(event.urlAfterRedirects);
            }
        });
    }

    // getSideBarlinks() {
    //     let url = `${this.base_url}sidebar_links/`;
    //     return this.http.get<Sidebar>(url);
    // }

    getSideBarlinks() {
        let url = `${this.base_url}sidebar_links/`;
        return this.http
            .get<Sidebar>(url)
            .pipe(
                map((items) => {
                    return items.modules.map((modules) => {
                        modules.menus = modules.menus.map((menu) => {
                            menu = {
                                ...menu,
                                route: this.routeMasterService.getUrlByDBValue(
                                    menu.page_url
                                ),
                            };
                            return menu;
                        });
                        return items;
                    });
                })
            );
    }

    // getSideBarlinks1() {
    //     let url = `${this.base_url}sidebar_links/`;

    //     this.navList = this.http.get<Sidebar>(url);
    //     console.log(this.navList.modules);

    //     return this.http.get<Sidebar>(url).pipe(
    //         map((items) => {
    //             return items.modules.map((modules) => {
    //                 modules.menus = modules.menus.map((menu) => {
    //                     menu = {
    //                         ...menu,
    //                         route: this.routeMasterService.getUrlByDBValue(
    //                             menu.page_url
    //                         ),
    //                     };
    //                     return menu;
    //                 });
    //                 return items;
    //             });
    //         })
    //     );
    // }

    getListofPageUrls() {
        let url = `${ApiRoutes.Core}menu_details/?is_default_page_candidate=1`;
        return this.http.get<BackendListModel<any>>(url);
    }
}
